/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Error_Case_Exception_ConcurrentInputs */

const en_api_error_case_exception_concurrent = /** @type {(inputs: Api_Error_Case_Exception_ConcurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The case changed while resolving the exception.`)
};

const pt_br2_api_error_case_exception_concurrent = /** @type {(inputs: Api_Error_Case_Exception_ConcurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O caso foi alterado durante a resolução da exceção.`)
};

/**
* | output |
* | --- |
* | "The case changed while resolving the exception." |
*
* @param {Api_Error_Case_Exception_ConcurrentInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const api_error_case_exception_concurrent = /** @type {((inputs?: Api_Error_Case_Exception_ConcurrentInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Error_Case_Exception_ConcurrentInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_error_case_exception_concurrent(inputs)
	return pt_br2_api_error_case_exception_concurrent(inputs)
});